/** **THIS FILE IS GENERATED AUTOMATICALLY. DO NOT EDIT.**
*
* This regex string is generated using the package.json ***supportedBrowsers*** command.
* It is generated based on .browserslistrc.
* If the user agent passes the test, then we should have full support for that system.
* This is not a full proof system and should only be used to do basic checks for compatability.
* Even if the check fails, the user might still be able to fully use our website.
*
* @example command usage
* npm run supportedBrowsers
*
* @example test usage
* import supportedBrowsers from './supportedBrowsers.js';
* if (supportedBrowsers.test(navigator.userAgent)) ...
*/

export default /Edge?\/(12[2-9]|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(1{2}[89]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(1{2}[7-9]|1[2-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android:?[ /-](12[5-9]|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Android.+Firefox\/(12[6-9]|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(12[5-9]|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+/
